import context, { IAppUserContext } from '@truckdown/components-systems';
import registerLocations from '@truckdown/locations';
import registerAccounts from '@truckdown/accounts';
import registerPromotions from '@truckdown/promotions';
import registerBilling from '@truckdown/billing';
import prerequisites from '@truckdown/components-locations';

prerequisites.registerPrerequisites(context);

registerLocations(context);
registerAccounts(context);
registerPromotions(context);
registerBilling(context);

import './empty-banner.png';

import './Components';
import './Styles/main.less';

context.initialize().then(() => {
    console.log('System initialized');
});
